import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { SHIPMENT_STAGES } from '#/entities/shipment'
import { useGetShipmentApiV1ShipmentsShipmentIdGet } from '#/shared/api/generated/shipment/theCargoShipment'
import { useDocumentTitle } from '#/shared/lib/document-title'
import { OrderForm } from '#/widgets/order-form'
import { shipmentToOrderFormDefaults } from '#/widgets/order-form/lib/to-form-defaults'
import { useUpdateShipment } from '#/widgets/order-form/model/use-update-shipment'
import type { OrderFormPayload } from '#/widgets/order-form'

interface LeadEditPageProps {
  shipmentId: string
  onClose?: () => void
}

export function LeadEditPage({ shipmentId, onClose }: LeadEditPageProps) {
  const { t } = useTranslation()
  const shipmentQuery = useGetShipmentApiV1ShipmentsShipmentIdGet(shipmentId, {
    query: { enabled: Boolean(shipmentId) },
  })
  const shipment = shipmentQuery.data?.data
  useDocumentTitle(shipment?.code, t('documentTitle.editLead'))
  const defaults = useMemo(
    () => shipmentToOrderFormDefaults(shipment),
    [shipment],
  )
  const update = useUpdateShipment({
    shipmentId,
    customer: {
      id: shipment?.customer?.id,
      email: shipment?.customer?.email ?? undefined,
    },
  })

  const handleSubmit = async (payload: OrderFormPayload) => {
    const saved = await update.submit(payload)
    if (!saved) return
    onClose?.()
  }

  if (!shipment) return null

  return (
    <OrderForm
      stage={SHIPMENT_STAGES.LEAD}
      defaultValues={defaults}
      shipmentId={shipmentId}
      onCancel={onClose}
      onSubmit={handleSubmit}
      isSubmitting={update.isSubmitting}
    />
  )
}
